import type { ReactElement } from "react";

import { List } from "immutable";

type TProviderProps = {
  children: ReactElement<unknown>;
  providers: FC | FC[];
};

export function Provider({ children, providers }: TProviderProps) {
  if (!Array.isArray(providers)) {
    providers = [providers];
  }
  // We reverse so the order of the array is the order of wrappers
  const reversedProviders = List(providers).reverse();

  let ComponentChildren = children;
  ComponentChildren = reversedProviders.reduce((innerChildren, CurrentProvider) => {
    return <CurrentProvider>{innerChildren}</CurrentProvider>;
  }, ComponentChildren);

  return ComponentChildren;
}
